import { notFound } from '@tanstack/react-router'
import { queryClient } from '@/app/queryClient'
import { featureFlagsQueryOptions } from '@/shared/api/featureFlagsQueries'

/**
 * Route beforeLoad guard: a module absent from the public feature-flags snapshot, or present with
 * `enabled: false`, must be genuinely unreachable - a real 404, not a page rendering disabled copy.
 */
export async function requireModuleFeatureFlag(moduleSlug: string): Promise<void> {
  const flags = await queryClient.ensureQueryData(featureFlagsQueryOptions)
  const enabled = flags.find((row) => row.module_name === moduleSlug)?.enabled === true

  if (!enabled) {
    throw notFound()
  }
}
